module.exports = __webpack_public_path__ + "img/goods7_6.14946c03.jpg";